import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import NotFound from "./page/notFound";
import TitleSetter from "./context/titleSetter";
import { DrawerTransitionProvider } from "./context/drawerProvider";
import { Provider } from "react-redux";
import store from "./redux/store";
import PortalLayoutWrapper from "./page/portalLayoutWrapper";

const App = () => {
  return (
    <Provider store={store}>
      <Router>
        <TitleSetter />
        <DrawerTransitionProvider>
          <Routes>
            {/* Redirect root to /id */}
            <Route path="/" element={<Navigate to="/id" replace />} />

            {/* Group all routes under /:lang */}
            <Route path="/:language/*" element={<PortalLayoutWrapper />} />

            {/* Catch everything else */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </DrawerTransitionProvider>
      </Router>
    </Provider>
  );
};

export default App;
